import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

import { showDialogAction } from 'components/redux-dialog/actions';
import { UIT_VIDEO_DOWNLOAD_DIALOG } from 'pages/page/fragments/uit-download-video-dialog';
import { Button } from 'components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { getUITVideoisDownloadableSelector } from 'components/video-box/selectors';

export const DownloadVideo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDownloadable = useSelector(getUITVideoisDownloadableSelector);
  const showDialog = () => dispatch(showDialogAction(UIT_VIDEO_DOWNLOAD_DIALOG));

  if (!isDownloadable) {
    return false;
  }
  return (
    <div>
      <div data-tooltip-content={t('download_video')} data-tooltip-id="downloadTooltip" data-delay-show={1000}>
        <Button icon={true} secondary={true} className="ct-download-button" onClick={() => showDialog()}>
          <FontAwesomeIcon icon={faDownload} />
        </Button>
      </div>
      <Tooltip
        id="downloadTooltip"
        place="top"
        effect="solid"
        type="dark"
        className={'tooltip-restyle'}
        globalEventOff="click"
      />
    </div>
  );
};
